import { render, staticRenderFns } from "./IconVideoOff.vue?vue&type=template&id=0af2dc44&"
import script from "./IconVideoOff.vue?vue&type=script&lang=ts&"
export * from "./IconVideoOff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports